import { Routes, Route, useLocation } from "react-router-dom";
import { ConfigProvider } from "antd";

import { Equipments } from "./features/equipment";
import "antd/dist/reset.css";
import "./App.css";
import { redirectLogin, useSession, useSubscription } from "./helpers/auth/useSession";
import { User } from "./features/user";
import { Task } from "./features/task";
import { Worklog } from "./features/worklog";
import { Client } from "./features/client";
import { EquipmentPreCheckQxn } from "./features/equipmentPreCheckQxn";
import { EquipmentPreCheckAns } from "./features/equipmentPreCheckAns";
import AppLayout from "./components/Layout";
import SummaryView from "./pages/Summary";
import ProjectsView from "./pages/projects/ProjectsView";
import EquipmentsView from "./pages/equipments/EquipmentsView";
import ProjectDetailView from "./pages/projects/ProjectDetailView";
import EquipmentView from "./pages/equipments/EquipmentView";
import EquipmentFormView from "./pages/equipments/EquipmentFormView";
import ProjectForm from "./pages/projects/ProjectForm";

import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import UserFormView from "./pages/users/UserFormView";
import UsersView from "./pages/users/UsersView";
import UserView from "./pages/users/UserView";
import LoadingModal from "./components/shared/LoadingModal";
import ClientsView from "./pages/clients/ClientsView";
import ClientFormView from "./pages/clients/ClientFormView";
import ClientView from "./pages/clients/ClientView";
import WorkLogsView from "./pages/worklogs/worklogsView";
import PageNotFound from "./pages/404/PageNotFound";
import EquipmentAccessoriesView from "./pages/equipmentAccessories/EquipmentAccessoriesView";
import { LogSignView } from "./pages/worklogs/logSignView";
import Login from "./pages/auth/login";
import ForgotPassword from "./pages/auth/forgotPassword";
import ResetPassword from "./pages/auth/resetPassword";
import UserRegistration from "./pages/auth/userRegistration";
import UserEmailVerification from "./pages/auth/userEmailVerification";
import CompanyRegistration from "./pages/auth/companyRegisteration";
import CompanyVerification from "./pages/auth/companyVerification";
import Restricted from "./pages/auth/restricted";
import SettingsView from "./pages/settings/SettingsView";
import NoCompany from "./pages/auth/noCompany";
import NotSubscribed from "./pages/auth/notSubscribed";
import UnsubscribeSuccessPage from "./pages/auth/unsubscribed";
import EquipmentDocumentsView from "./pages/equipments/EquipmentDocumentsView";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

function App() {
  const { user, login } = useSession();
  const { subscribed } = useSubscription();
  console.log({ subscribed })

  // const { pathname } = useLocation();

  // useEffect(() => {
  //   if (login) {
  //     redirectLogin();
  //     return;
  //   }
  // }, [login]);

  if (login) {
    return (
      <ConfigProvider
        theme={{
          token: {
            // colorPrimary: "#f1982000",
            fontFamily: "'Roboto', sans-serif",
          },
        }}
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/sign-dock-off-site" element={<LogSignView />} />
          <Route path="/equipment-documents/:token" element={<EquipmentDocumentsView />} />
          <Route path="/company-register" element={<CompanyRegistration />} />
          <Route path="/user-register" element={<UserRegistration />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<UserEmailVerification />} />
          <Route path="/verify-company" element={<CompanyVerification />} />
          <Route path="/unsubscribed" element={<UnsubscribeSuccessPage />} />
          <Route path="*" element={<Login />} />
        </Routes>
      </ConfigProvider>
    );
  }

  if (!user) return <LoadingModal />;

  if (!subscribed) {
    return (
      <ConfigProvider>
        <Routes>
          <Route path="*" element={<NotSubscribed />} />
        </Routes>
      </ConfigProvider>
    )
  }

  if (!user.company || !user.role) {
    return (
      <ConfigProvider>
        <Routes>
          <Route path="*" element={<NoCompany />} />
        </Routes>
      </ConfigProvider>
    )
  }

  if (user.role !== "admin" && user.role !== "account_manager") {
    return (
      <ConfigProvider>
        <Routes>
          <Route path="*" element={<Restricted />} />
        </Routes>
      </ConfigProvider>
    )
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#fa9614",
          fontFamily: "'Roboto', sans-serif",
          borderRadiusLG: 0,
          borderRadius: 0,
        },
      }}
    >
      <Routes>
        <Route path="/" element={<AppLayout user={user} />}>
          <Route path="/" element={<SummaryView user={user} />} />
          <Route path="/users-old" element={<User user={user} />} />
          <Route path="/equipments-old" element={<Equipments user={user} />} />
          <Route path="/tasks" element={<Task user={user} />} />
          <Route path="/clients-old" element={<Client user={user} />} />
          <Route
            path="/equipments-precheck-qxn"
            element={<EquipmentPreCheckQxn user={user} />}
          />
          <Route
            path="/equipments-precheck-ans"
            element={<EquipmentPreCheckAns user={user} />}
          />
          {/* <Route path="/tasks/:taskId/work-log" element={<Worklog user={user} />} /> */}
          <Route path="/old-worklog" element={<Worklog user={user} />} />

          <Route path="/worklogs" element={<WorkLogsView user={user} />} />
          <Route
            path="/equipment-accessories"
            element={<EquipmentAccessoriesView />}
          />

          <Route path="/projects" element={<ProjectsView user={user} />} />
          <Route path="/projects/:projectId" element={<ProjectDetailView user={user} />} />
          <Route path="/projects/form" element={<ProjectForm />} />
          <Route path="/projects/form/:projectId" element={<ProjectForm />} />

          <Route path="/equipments" element={<EquipmentsView />} />
          <Route path="/equipments/:equipmentId" element={<EquipmentView />} />
          <Route path="/equipments/form" element={<EquipmentFormView />} />
          <Route
            path="/equipments/form/:equipmentId"
            element={<EquipmentFormView />}
          />

          <Route path="/users" element={<UsersView />} />
          <Route path="/users/:userId" element={<UserView />} />
          <Route path="/users/form" element={<UserFormView />} />
          <Route path="/users/form/:userId" element={<UserFormView />} />
          <Route path="/settings" element={<SettingsView user={user} />} />

          <Route path="/clients" element={<ClientsView user={user} />} />
          <Route path="/clients/:clientId" element={<ClientView user={user} />} />
          <Route path="/clients/form" element={<ClientFormView />} />
          <Route path="/clients/form/:clientId" element={<ClientFormView />} />

          <Route path="/sign-dock-off-site" element={<LogSignView hideHeader />} />

        </Route>
        <Route path="/equipment-documents/:token" element={<EquipmentDocumentsView hideHeader />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </ConfigProvider>
  );
}

export default App;
